import { IRootState } from 'reducers';

const studyGiaListSelector = (state: IRootState) => state.studentGiaList.content;

export default studyGiaListSelector;
